var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('h2',{staticClass:"mb-5"},[_vm._v("Merchants")]),_c('vx-card',[_c('ag-grid-vue',{staticClass:"ag-theme-material w-100 my-4 ag-grid-table",attrs:{"rowSelection":"multiple","colResizeDefault":"shift","columnDefs":_vm.columnDefs,"rowData":_vm.items}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }